import VrAuto from "./VrAuto.container";

export default VrAuto;
